import { FC, ReactElement, useEffect, useRef, useState } from 'react';
import { ISelectOption } from '@widgets/multi-select';
interface IDropdownButtonProps {
  options: ISelectOption[];
  className?: string | null;
  title?: string | ReactElement | null;
  style?: object;
  onSelect: (value: any) => void;
  leftPx?: number;
}
export interface IDropdownButtonOption {
  code: string;
  name: string;
}
export const DropdownButton: FC<IDropdownButtonProps> = ({
  options,
  title = '',
  className = '',
  leftPx = -15,
  style = {},
  onSelect,
}) => {
  const [isToggled, setIsToggled] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handler(e: Event) {
      if (dropdownRef.current) {
        // @ts-ignore
        if (!dropdownRef.current?.contains(e.target)) {
          setIsToggled(false);
        }
      }
    }
    document.addEventListener('click', handler);
    return () => {
      document.removeEventListener('click', handler);
    };
  }, [dropdownRef?.current]);

  return (
    <div ref={dropdownRef} className={`relative flex items-center ${className} `} style={style}>
      <button
        className="w-full h-full flex justify-center items-center"
        onClick={() => {
          setIsToggled(!isToggled);
        }}
      >
        {title}
      </button>
      <div
        className={`${isToggled ? 'visible' : 'invisible'} absolute rounded-[10px] bg-[#252328] px-[13px] py-[8px] top-[35px] z-10`}
        style={{
          left: leftPx,
        }}
      >
        <ul className="text-left whitespace-nowrap text-[12px] cursor-pointer">
          {options.map((option, key) => (
            <li
              key={key}
              className="py-2"
              onClick={() => {
                setIsToggled(false);
                onSelect(option.value);
              }}
            >
              {option.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
export default DropdownButton;
